import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Confirm Component
 */
let ConfirmComponent = class ConfirmComponent {
    constructor(sanitizer, themeService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.secondColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
    }
    delete() {
        this.success();
        this.close();
    }
    close() {
        this.modal.destroy();
    }
};
ConfirmComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ConfirmComponent = __decorate([
    Component({
        selector: 'ecd-confirm-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./confirm.component.html")).default
    })
], ConfirmComponent);
export { ConfirmComponent };
